import React from "react";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminTable from "../Helpers/AdminTable";
import TableTitle from "../Helpers/TableTitle";
import { useState } from "react";
import SureModal from "src/components/Modals/SureModal";
import { galeryAction } from "src/store/Slices/Administrator/GalerySlice";
import AddEditGaleryModal from "./Modals/AddEditGaleryModal";
import fallback from "./fallback.png";
import { copyToClipboard } from "src/components/helpers/copyToClipboard";
import { Image } from "antd";
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable";

const Galery = ({ mnemo }) => {
    const dispatch = useDispatch();
    const searchInput = useRef(null);

    const items = [
        {
            key: "1",
            label: "Редактировать",
            onClick: () => {
                setIsOpenAddEditModal({ open: true, flag: "edit" });
            },
            disabled: !mnemo?.children?.find((el) => el.mnemo === "updateBtn"),
        },
        {
            key: "2",
            label: "Удалить",
            onClick: () => {
                setIsOpenDeleteModal(true);
            },
            disabled: !mnemo?.children?.find((el) => el.mnemo === "deleteBtn"),
        },
        {
            key: "3",
            label: "Получить ссылку на изображение",
            onClick: () => {
                copyToClipboard(galeryInfo?.imageUrl?.props?.src);
            },
            // disabled: !mnemo?.children?.find(el => el.mnemo === 'getImageLink')
        },
    ];

    const filterOptionsArr = [
        { label: "Фильрация", value: 0, index: undefined },
        { label: "По номеру", value: 1, index: "id", title: "Галерея" },
        {
            label: "По наименование",
            value: 2,
            index: "name",
            title: "Наименование",
        },
        { label: "По клубу", value: 3, index: "clubName", title: "Клуб" },
        {
            label: "По изображению",
            value: 4,
            index: "imageUrl",
            title: "Изображение",
        },
    ];

    const [isDeleted, setIsDeleted] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [galeryInfo, setGaleryInfo] = useState();
    const [isOpenAddEditModal, setIsOpenAddEditModal] = useState({
        open: false,
        flag: "",
    });
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

    // STORE
    const galeryList = useSelector((state) => state.GalerySlice.galeryList);
    const galeryListLoading = useSelector(
        (state) => state.GalerySlice.galeryListLoading
    );

    const onClickDelete = () => {
        dispatch(
            galeryAction({ flag: "delete", value: { id: galeryInfo.id } })
        ).then(() => {
            dispatch(galeryAction({ flag: "get" }));
            setIsOpenDeleteModal(false);
        });
        setPage(1);
        setPageSize(20);
    };

    const clickOnAction = (element) => {
        setGaleryInfo(element);
    };

    const onClickSearchItem = (selectedKeys, dataIndex) => {
        setPage(1);
        setPageSize(20);
        dispatch(
            galeryAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    [`${dataIndex}`]: selectedKeys[0],
                },
            })
        );
    };

    const handlePaginationChange = (page, pageSize) => {
        dispatch(
            galeryAction({
                flag: "get",
                value: {
                    count: pageSize,
                    offset: pageSize * (page - 1),
                },
            })
        );
        setPage(page);
        setPageSize(pageSize);
    };

    const searchItemsMap = (keys, values) => {
        const formattedItems = {};
        if (keys && values) {
            keys.forEach((key, index) => {
                if (values[index] && values[index][0]) {
                    if (key === "id") {
                        formattedItems["idFrom"] = values[index][0];
                        formattedItems["idTo"] = values[index][1];
                    } else if (key === "date") {
                        formattedItems["DateFrom"] = values[index][0];
                        formattedItems["DateTo"] = values[index][1];
                    } else if (key === "clubName") {
                        formattedItems["ClubId"] = values[index][0];
                    } else if (key === "time") {
                        formattedItems["TimeFrom"] = values[index][0];
                        formattedItems["TimeTo"] = values[index][1];
                    } else {
                        formattedItems[key] = values[index][0];
                    }
                }
            });
            return formattedItems;
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        const payload = searchItemsMap(
            Object.keys(filters),
            Object.values(filters)
        );
        dispatch(
            galeryAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    count: pagination.pageSize,
                    offset: pagination.pageSize * (pagination.current - 1),
                    orderBy: sorter?.column?.dataIndex,
                    isDesc: sorter.order
                        ? sorter.order === "ascend"
                            ? true
                            : false
                        : undefined,
                    ...payload,
                },
            })
        );
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    useEffect(() => {
        dispatch(galeryAction({ flag: "get" }));
    }, []);

    const showDeletedItems = (value) => {
        setIsDeleted(value);
        dispatch(galeryAction({ flag: "get", value: { isDeleted: value } }));
        setPage(1);
        setPageSize(20);
    };

    const formatedRows = galeryList?.data?.value?.rows.map((element) => ({
        ...element,
        imageUrl: (
            <Image
                alt="Отсутствует изображение"
                width={120}
                src={element?.imageUrl}
                fallback={
                    fallback || "https://placehold.co/400x400?text=No+Photo"
                }
            />
        ),
    }));

    return (
        <>
            <AddEditGaleryModal
                visible={isOpenAddEditModal}
                setVisible={setIsOpenAddEditModal}
                galeryInfo={galeryInfo}
                setPage={setPage}
                setPageSize={setPageSize}
            />
            <SureModal
                visible={isOpenDeleteModal}
                setVisible={setIsOpenDeleteModal}
                onClickYes={onClickDelete}
            />
            {window.innerWidth >= 768 ? (
                <AdminTable
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    onChange={handleTableChange}
                    loading={galeryListLoading}
                    onClickRowOne={(record) => {
                        setGaleryInfo(record);
                    }}
                    columns={galeryList}
                    rows={formatedRows}
                    total={galeryList?.data?.value?.totalCount}
                    title={() => (
                        <TableTitle
                            isDeleted={isDeleted}
                            showDeletedItems={showDeletedItems}
                            onClickOpenModal={() => {
                                setIsOpenAddEditModal({
                                    open: true,
                                    flag: "add",
                                });
                            }}
                            mnemoButton={
                                !mnemo?.children?.find(
                                    (el) => el.mnemo === "insertBtn"
                                )
                            }
                            mnemoSwitcher={
                                !mnemo?.children?.find(
                                    (el) => el.mnemo === "isDeletedBtn"
                                )
                            }
                        />
                    )}
                    items={items}
                    isDeleted={isDeleted}
                />
            ) : (
                <AntdMobileTable
                    page={page}
                    setPage={setPage}
                    setPageSize={setPageSize}
                    elementsList={galeryList}
                    elementsListLoading={galeryListLoading}
                    setIsOpenAddEditModal={setIsOpenAddEditModal}
                    setIsOpenDeleteModal={setIsOpenDeleteModal}
                    items={items}
                    onChange={handleTableChange}
                    filterOptionsArr={filterOptionsArr}
                    clickOnAction={clickOnAction}
                    handlePaginationChange={handlePaginationChange}
                    searchInput={searchInput}
                    onClickSearchItem={onClickSearchItem}
                />
            )}
        </>
    );
};

export default Galery;
